import GlobalCancel from "@assets/icons/global-cancel.svg";
import Global from "@assets/icons/global.svg";
import { Battery } from "@components/battery";
import { DeviceDescription as DeviceType } from "@features/device/api";
import { formatTime } from "@helpers/date";
import classNames from "classnames";
import { useMemo } from "react";
import styles from "./device.module.scss";

type Props = Pick<
  DeviceType,
  "name" | "charge" | "active" | "at_work" | "deleted"
>;

export const Device = ({ charge, name, active, at_work, deleted }: Props) => {
  const time = useMemo(() => formatTime(new Date()), []);

  const isActive = useMemo(
    () => !deleted && active && at_work,
    [active, at_work, deleted]
  );

  return (
    <div className={styles.deviceImage}>
      <div className={styles.deviceDisplay}>
        <div className={styles.deviceHeader}>
          <span className={styles.time}>{time}</span>
          <Battery battery={charge} />
        </div>
        <div className={styles.deviceContent}>
          <p className={styles.name}>{name}</p>
          {isActive ? <Global /> : <GlobalCancel />}

          {deleted ? (
            <p className={classNames(styles.status, styles.offline)}>
              В архиве
            </p>
          ) : (
            <>
              <p
                className={classNames(
                  styles.status,
                  active ? styles.online : styles.offline
                )}
              >
                {active ? "В сети" : "Не в сети"}
              </p>
              <p
                className={classNames(
                  styles.status,
                  at_work ? styles.online : styles.offline
                )}
              >
                {at_work ? "Активно" : "Не активно"}
              </p>
            </>
          )}
        </div>
      </div>
      <div className={styles.deviceButton}></div>
    </div>
  );
};
